// Diccionario bilingue (es/en) para la página pública de reservas.
// Solo se usa aca: el panel interno de administracion queda en espanol.

export const translations = {
  es: {
    stepper: { stepLabel: 'Paso {current} de {total}' },
    steps: {
      1: { title: 'Elegi un servicio' },
      2: { title: 'Elegi un profesional' },
      3: { title: 'Fecha y hora' },
      4: { title: 'Tus datos' },
    },
    common: {
      back: 'Volver',
      continue: 'Continuar',
      optional: 'opcional',
      minutesShort: 'min',
      whatsappHelp: '¿Tenés dudas? Escribinos',
      consultationBadge: 'Valoración',
      reviewBadge: 'Revisión',
    },
    step1: {
      empty: 'Todavía no hay servicios disponibles para reservar online.',
      readMore: 'Ver más',
      readLess: 'Ver menos',
      allCategories: 'Todos',
      featuredTitle: '¿Primera vez o control?',
      featuredConsultationCopy: '¿Primera vez? Reservá tu consulta de valoración',
      featuredReviewCopy: '¿Ya te trataste con nosotros? Reservá tu control',
      featuredModelCopy: '¿Querés ser modelo? Sumate a nuestra convocatoria',
    },
    step2: {
      anyName: 'Cualquiera disponible',
      anyDesc: 'Te asignamos el primer horario libre',
    },
    step3: {
      dateLabel: 'Elegi el día',
      timeLabel: 'Horarios disponibles',
      noSlots: 'No hay horarios disponibles este día. Proba otra fecha.',
    },
    step4: {
      name: 'Nombre completo',
      phone: 'Teléfono',
      email: 'Email',
      dob: 'Fecha de nacimiento',
      emergencyName: 'Contacto de emergencia',
      emergencyPhone: 'Teléfono de emergencia',
      allergies: 'Alergias / observaciones médicas',
      allergiesPlaceholder: "Escribí 'Ninguna' si no tenés",
      reason: 'Motivo de consulta',
      confirm: 'Confirmar reserva',
      errors: {
        name: 'Ingresa tu nombre completo',
        phone: 'Ingresa un teléfono válido',
        email: 'Ingresa un email válido',
        dob: 'Ingresa tu fecha de nacimiento',
        emergencyName: 'Ingresa el nombre de tu contacto de emergencia',
        emergencyPhone: 'Ingresa el teléfono de tu contacto de emergencia',
        allergies: 'Contanos si tenés alergias (o escribí "Ninguna")',
      },
    },
    step5: {
      title: '¡Reserva confirmada!',
      subtitle: 'Te esperamos. Pronto nos pondremos en contacto para confirmar tu turno.',
      service: 'Servicio',
      professional: 'Profesional',
      date: 'Fecha',
      time: 'Hora',
      address: 'Dirección',
      pendingNote: 'Tu turno quedo registrado como pendiente de confirmacion.',
      newBooking: 'Hacer otra reserva',
      depositRequired: 'Para confirmar tu turno, te pedimos una seña',
      paymentRequired: 'Para confirmar tu turno, completa el pago',
      paymentAmount: 'Monto',
      payNow: 'Pagar ahora',
    },
    footer: {
      rights: 'Todos los derechos reservados.',
    },
    landing: {
      // Fix C (2026-09-04): el CTA del encabezado decia "Reservar turno" y el
      // resto de la landing "Agenda tu cita". Se unifica con el manual de marca.
      nav: { treatments: 'Tratamientos', doctor: 'La Dra. Strani', team: 'Equipo', results: 'Resultados', faq: 'Preguntas frecuentes', contact: 'Contacto', cta: 'Agenda tu cita' },
      hero: { defaultTitle: 'Realza tu belleza. Eleva tu esencia.', titleLine1: 'Realza tu belleza.', titleLine2: 'Eleva tu esencia.', defaultSubtitle: 'Medicina estética de lujo', defaultQuote: 'Cada tratamiento es cuidadosamente diseñado y planificado, aplicando ciencia, experiencia médica y tecnología innovadora para realzar tu belleza natural.', cta: 'Agenda tu cita', scrollHint: 'Descubre más' },
      trust: { tech: 'Tecnología avanzada', natural: 'Resultados naturales', personalized: 'Tratamientos personalizados', experts: 'Expertos en tu belleza' },
      lines: { facial: 'Rejuvenecimiento facial', body: 'Contorno corporal', coaching: 'Coaching estético' },
      stats: { years: 'Años de experiencia', patients: 'Pacientes atendidas', treatments: 'Tratamientos realizados' },
      promos: { sectionTitle: 'Promociones vigentes', subtitle: 'Por tiempo limitado', badge: 'Promoción' },
      featured: { consultationCta: 'Reservá tu consulta de valoración', reviewCta: 'Reservá tu control post-tratamiento', firstTime: '¿Primera vez?', returning: '¿Ya te trataste con nosotros?', modelTitle: '¿Querés ser modelo?', modelCta: 'Sumate a nuestra convocatoria' },
      financing: { title: 'Financiá tu tratamiento', cta: 'Conocé las opciones' },
      intro: { defaultTitle: 'Nuestro enfoque' },
      treatments: { sectionTitle: 'Tratamientos', allCategories: 'Todos', ctaBook: 'Reservar', from: 'Desde' },
      doctor: { sectionTitle: 'La Dra. Strani', defaultRole: 'Directora médica' },
      // Fix AZ (2026-10-30): seccion del equipo de profesionales
      team: { sectionTitle: 'Nuestro equipo', subtitle: 'Profesionales que te acompañan en cada tratamiento.', whatsapp: 'Escribinos por WhatsApp', whatsappMessage: 'Hola, quiero hacer una consulta con el equipo de Strani.' },
      results: { sectionTitle: 'Resultados', before: 'Antes', after: 'Después' },
      testimonials: { sectionTitle: 'Lo que dicen nuestras pacientes' },
      // Fix BD (2026-10-30): novedades de redes
      news: { sectionTitle: 'Novedades', subtitle: 'Lo último de nuestras redes.', viewOn: 'Ver en {platform}', follow: 'Seguinos en {platform}' },
      faq: { sectionTitle: 'Preguntas frecuentes' },
      visit: { sectionTitle: 'Visítanos', hoursLabel: 'Horarios de atención' },
      closing: { title: 'Porque sí.', script: 'Porque te lo mereces.', subtitle: 'Agenda tu cita hoy mismo.', cta: 'Agenda tu cita' },
      footer: { legal: 'Toda la información médica se brinda bajo criterio profesional. Los resultados pueden variar según cada paciente.' },
    },
  },
  en: {
    stepper: { stepLabel: 'Step {current} of {total}' },
    steps: {
      1: { title: 'Choose a service' },
      2: { title: 'Choose a professional' },
      3: { title: 'Date & time' },
      4: { title: 'Your details' },
    },
    common: {
      back: 'Back',
      continue: 'Continue',
      optional: 'optional',
      minutesShort: 'min',
      whatsappHelp: 'Questions? Chat with us',
      consultationBadge: 'Consultation',
      reviewBadge: 'Follow-up',
    },
    step1: {
      empty: 'No services available for online booking yet.',
      readMore: 'Read more',
      readLess: 'Read less',
      allCategories: 'All',
      featuredTitle: 'First visit or follow-up?',
      featuredConsultationCopy: 'First time here? Book your valuation consultation',
      featuredReviewCopy: 'Already a patient? Book your follow-up',
      featuredModelCopy: 'Want to be a model? Join our casting call',
    },
    step2: {
      anyName: 'Any available',
      anyDesc: "We'll assign the first open slot",
    },
    step3: {
      dateLabel: 'Choose a day',
      timeLabel: 'Available times',
      noSlots: 'No available times this day. Try another date.',
    },
    step4: {
      name: 'Full name',
      phone: 'Phone',
      email: 'Email',
      dob: 'Date of birth',
      emergencyName: 'Emergency contact',
      emergencyPhone: 'Emergency phone',
      allergies: 'Allergies / medical notes',
      allergiesPlaceholder: "Write 'None' if you don't have any",
      reason: 'Reason for visit',
      confirm: 'Confirm booking',
      errors: {
        name: 'Enter your full name',
        phone: 'Enter a valid phone number',
        email: 'Enter a valid email address',
        dob: 'Enter your date of birth',
        emergencyName: 'Enter your emergency contact name',
        emergencyPhone: 'Enter your emergency contact phone',
        allergies: 'Tell us about any allergies (or write "None")',
      },
    },
    step5: {
      title: 'Booking confirmed!',
      subtitle: "We can't wait to see you. We'll be in touch soon to confirm your appointment.",
      service: 'Service',
      professional: 'Professional',
      date: 'Date',
      time: 'Time',
      address: 'Address',
      pendingNote: 'Your appointment was registered as pending confirmation.',
      newBooking: 'Book another appointment',
      depositRequired: 'To confirm your appointment, we ask for a deposit',
      paymentRequired: 'To confirm your appointment, please complete the payment',
      paymentAmount: 'Amount',
      payNow: 'Pay now',
    },
    footer: {
      rights: 'All rights reserved.',
    },
    landing: {
      // Fix C (2026-09-04): mismo CTA que el hero y el cierre.
      nav: { treatments: 'Treatments', doctor: 'Dr. Strani', team: 'Our team', results: 'Results', faq: 'FAQ', contact: 'Contact', cta: 'Book your appointment' },
      hero: { defaultTitle: 'Enhance your beauty. Elevate your essence.', titleLine1: 'Enhance your beauty.', titleLine2: 'Elevate your essence.', defaultSubtitle: 'Luxury aesthetic medicine', defaultQuote: 'Every treatment is carefully designed and planned, applying science, medical expertise and innovative technology to enhance your natural beauty.', cta: 'Book your appointment', scrollHint: 'Discover more' },
      trust: { tech: 'Advanced technology', natural: 'Natural results', personalized: 'Personalized treatments', experts: 'Beauty experts' },
      lines: { facial: 'Facial rejuvenation', body: 'Body contouring', coaching: 'Aesthetic coaching' },
      stats: { years: 'Years of experience', patients: 'Patients treated', treatments: 'Treatments performed' },
      promos: { sectionTitle: 'Current promotions', subtitle: 'For a limited time', badge: 'Promotion' },
      featured: { consultationCta: 'Book your valuation consultation', reviewCta: 'Book your post-treatment follow-up', firstTime: 'First time?', returning: 'Already a patient?', modelTitle: 'Want to be a model?', modelCta: 'Join our casting call' },
      financing: { title: 'Finance your treatment', cta: 'See the options' },
      intro: { defaultTitle: 'Our approach' },
      treatments: { sectionTitle: 'Treatments', allCategories: 'All', ctaBook: 'Book', from: 'From' },
      doctor: { sectionTitle: 'Dr. Strani', defaultRole: 'Medical director' },
      team: { sectionTitle: 'Our team', subtitle: 'The professionals who take care of you in every treatment.', whatsapp: 'Message us on WhatsApp', whatsappMessage: 'Hi, I have a question for the Strani team.' },
      results: { sectionTitle: 'Results', before: 'Before', after: 'After' },
      testimonials: { sectionTitle: 'What our patients say' },
      news: { sectionTitle: 'News', subtitle: 'The latest from our social media.', viewOn: 'View on {platform}', follow: 'Follow us on {platform}' },
      faq: { sectionTitle: 'Frequently asked questions' },
      visit: { sectionTitle: 'Visit us', hoursLabel: 'Business hours' },
      closing: { title: 'Just because.', script: 'Because you deserve it.', subtitle: 'Book your appointment today.', cta: 'Book your appointment' },
      footer: { legal: 'All medical information is provided under professional judgment. Results may vary by patient.' },
    },
  },
};
